import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions';

import { IconButton, Tooltip } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

import DetallesComprobanteVenta from '../DetallesComprobanteVenta/DetallesComprobanteVenta';
import DetallesComprobanteGasto from '../DetallesComprobanteGasto/DetallesComprobanteGasto';


const ModalDetallesComprobante = (props) => {
  const { onShowModal, comprobante, venta, gasto } = props;

  const onShowModalClick = () => {
    venta && onShowModal(<DetallesComprobanteVenta comprobante={comprobante} />);
    gasto && onShowModal(<DetallesComprobanteGasto comprobante={comprobante} />);
  };

  return (
    <div style={{ textAlign: 'right' }}>
      <Tooltip title="Ver detalles">
        <IconButton size="small" onClick={() => onShowModalClick()}>
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

const mapStateToProps = (state) => ({
  showModal: state.modals.globalModal.show
});

const mapDispatchToProps = (dispatch) => {
  return {
    onShowModal: (body) => dispatch(actions.showGlobalModal(true, '', body, undefined, true, true, 'lg')),
    onChangeModalBody: (newBody) => dispatch(actions.changeGlobalModalBody(newBody)),
    onLoadDetallesComprobante: (idSucursal, idSistema, idComproba, nroReferencia, cobranza, success, errorFail) =>
      dispatch(actions.loadDetalleComprobante(idSucursal, idSistema, idComproba, nroReferencia, success, errorFail, cobranza))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalDetallesComprobante);